const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export const formatRunDates = (start, end) => {
  if (!start) return "";
  const s = new Date(start);
  const sd = s.getDate();
  const sm = MONTHS[s.getMonth()];
  const sy = s.getFullYear();
  if (!end) return `${sd} ${sm} ${sy}`;
  const e = new Date(end);
  const ed = e.getDate();
  const em = MONTHS[e.getMonth()];
  const ey = e.getFullYear();
  if (sd === ed && sm === em && sy === ey) return `${sd} ${sm} ${sy}`;
  if (sm === em && sy === ey) return `${sd} to ${ed} ${sm} ${sy}`;
  if (sy === ey) return `${sd} ${sm} to ${ed} ${em} ${sy}`;
  return `${sd} ${sm} ${sy} to ${ed} ${em} ${ey}`;
};

export const exhibitionStatus = (start, end) => {
  const now = new Date();
  if (start && new Date(start) > now) return "UPCOMING";
  if (!end || new Date(end) >= now) return "NOW SHOWING";
  return "PAST";
};

export const displayDates = (ex) =>
  ex.date_display_override || formatRunDates(ex.start_date, ex.end_date);

export const focalToPosition = (focal) => {
  if (!focal) return undefined;
  const [x, y] = focal.split(",");
  return `${x || 50}% ${y || 50}%`;
};
